<template>
    <CModal
        title="Редактирование блюда"
        :show.sync="modal.visible"
        :footer="false"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm v-if="modal.item">
                    <CRow
                        v-if="restaurant"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Ресторан</CCol>
                        <CCol sm="9"
                              class="col-form-label">
                            <span> {{this.restaurant.label}} </span>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="dishes"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Блюдо</CCol>
                        <CCol sm="9">
                            <template v-if="modal.item.dish && modal.item.dish.id">
                                <span class="order-gd-item-edit__title">{{ modal.item.dish.title }}</span>
                            </template>
                            <template v-else>
                                <Autocomplete
                                    ref="autocomplete"
                                    placeholder="Введите ID или часть названия"
                                    :search="getDished"
                                    :get-result-value="getResultValue"
                                    @submit="updateDishes"
                                />
                            </template>

                            <!-- <CSelect
                                class="mb-0"
                                inline
                                :value="modal.item.dish ? modal.item.dish.id : null"
                                :options="dishes"
                                placeholder="Выберите блюдо..."
                                @update:value="updateDish"
                            /> -->
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена блюда</CCol>
                        <CCol sm="9" class="col-form-label">
                            {{ +modal.item.dish.price }} р.
                            <!-- <CInput
                                placeholder="Цена блюда"
                                v-model="modal.item.dish.price"
                            /> -->
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id && modifiers && modifiers.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Модификаторы:</CCol>
                        <template v-for="modifier in modifiers">
                            <CCol :key="modifier.id" sm="6">
                                <CInputRadio
                                    class="mb-0"
                                    inline
                                    name="modifier"
                                    :value="modifier.id"
                                    :checked="selectedModifier === modifier.id"
                                    @update:checked="updateModifiers"
                                />{{ modifier.title }} - {{ modifier.price }} р.
                            </CCol>
                        </template>
                    </CRow>

                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id && modifiersGroup && modifiersGroup.length"
                        form
                        class="form-group">
                        <br>
                        <CCol
                            v-if="modifiers.length === 0"
                            tag="label"
                            sm="12"
                            class="col-form-label">Модификаторы:</CCol>
                        <template v-for="group in modifiersGroup"> 
                            <CCol
                                :key="group.id"
                                tag="label"
                                sm="12"
                                class="col-form-label"> {{group.title}} </CCol>
                            <template v-for="modifier in group.modifiers">
                            <CCol :key="modifier.id" sm="6">
                                <CInputCheckbox
                                    class="mb-0"
                                    inline
                                    :value="modifier.id"
                                    :checked="selectedModifiersGroup.indexOf(modifier.id) >= 0"
                                    @update:checked="updateModifiersGroup"
                                />{{ modifier.title }} - {{ modifier.price }} р.
                            </CCol>
                        </template>
                        </template>
                    </CRow>

                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id && ingredients && ingredients.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Ингредиенты:</CCol>
                        <template v-for="ingredient in ingredients">
                            <CCol :key="ingredient.id" sm="6">
                                <CInputCheckbox
                                    class="mb-0"
                                    inline
                                    :value="ingredient.id"
                                    :checked="selectedIngredients.indexOf(ingredient.id) >= 0"
                                    @update:checked="updateIngredients"
                                />{{ ingredient.title }} - {{ ingredient.price }} р.
                            </CCol>
                        </template>
                    </CRow>

                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id && ingredientsGroup && ingredientsGroup.length"
                        form
                        class="form-group">
                        <CCol
                            v-if="ingredients.length === 0"
                            tag="label"
                            sm="12"
                            class="col-form-label">Ингредиенты:</CCol>
                        <template v-for="group in ingredientsGroup"> 
                            <CCol
                                :key="group.id"
                                tag="label"
                                sm="12"
                                class="col-form-label"> {{group.title}} </CCol>
                            <template v-for="ingredient in group.ingredients">
                                <CCol :key="ingredient.id" sm="6">
                                    <CInputCheckbox
                                        class="mb-0"
                                        inline
                                        :value="ingredient.id"
                                        :checked="selectedIngredients.indexOf(ingredient.id) >= 0"
                                        @update:checked="updateIngredientsGroup"
                                    />{{ ingredient.title }} - {{ ingredient.price }} р.
                                </CCol>
                            </template>
                        </template>
                    </CRow>

                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена позиции</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.price"
                                placeholder="Цена позиции"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Количество</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.quantity"
                                placeholder="Количество"
                            />
                        </CCol>
                    </CRow>
                    <!-- <CRow
                        v-if="modal.item.dish && modal.item.dish.id"
                        form
                        class="form-group align-items-center">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">Применить скидку заказа</CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="modal.item.applyDiscount"
                                class="pt-1" />
                        </CCol>
                    </CRow>
                    <CRow v-if="modal.item.dish && modal.item.dish.id" class="form-group pl-3 danger">
                        В случае если к заказу применена скидка, к этой позиции она будет применена после обновления заказа.
                    </CRow> -->
                    <CRow
                        v-if="modal.item.dish && modal.item.dish.id && !modal.item.isNewPosition"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Возврат</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value="modal.item.refund_for"
                                :options="refund_for"
                                placeholder="За счет..."
                                @update:value="updateRefund"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model="modal.item.refund_comment"
                                placeholder="Комментарий"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Сумма возврата</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model.number="modal.item.refund_sum"
                                :placeholder="modal.item.refund_sum ? modal.item.refund_sum : modal.item.price * modal.item.quantity"
                            />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CLink
                    v-if="restaurant"
                    :to="`/restaurants/${restaurant.value}/dishes/create`"
                    target="_blank">
                    <CButton
                        color="light"
                        class="ml-3" >
                            Создать новое блюдо 
                    </CButton>
                </CLink>
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('cancel')"
                >Отмена</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    :disabled="!(modal.item.dish && modal.item.dish.id)"
                    @click="$emit('update')"
                >Сохранить</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');
    import Autocomplete from '@trevoreyre/autocomplete-vue';

    export default {
        name: 'OrderRDItemInactiveEdit',

        components: {
            Autocomplete,
        },
        props: {
            modal: {
                type: Object,
                default: () => ({})
            },
        },

        data() {
            return {
                isAuthorized: false,
                order: {},
                restaurant: null,
                dishes: null,
                modifiers: null,
                ingredients: null,
                ingredientsGroup: [],
                modifiersGroup: [],
                refund_for: [{
                    value: 'МИРСИТИ',
                    label: 'МИРСИТИ'
                },{
                    value: 'Партнера',
                    label: 'Партнера'
                }],
            };
        },

        computed: {
            visible() {
                return this.modal.visible
            },
            selectedModifier() {
                return this.modal.item.modifiers && this.modal.item.modifiers.length ? this.modal.item.modifiers[0].id : null;
            },
            selectedIngredients() {
                return this.modal.item.ingredients.map(i => {
                    return i.id
                });
            },
            selectedModifiersGroup() {
                return this.modal.item.modifiers.map(m => {
                    return m.id
                });
            },
        },

        watch: {
            visible: async function (val) {
                try {
                    const { data } = await Vue.axios.get(`/restaurants/${this.order.rd.items[0].restaurant_id}`);
                    this.restaurant = {
                        value: data.id,
                        label: data.title
                    }
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных')
                }

                if (!this.modal.item.dish.id) {
                    this.modal.item = {
                        ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                        ...{
                            id: this.modal.item.id,
                            restaurant: {
                                id: this.restaurant.value,
                                title: this.restaurant.label
                            },
                            isNewPosition: this.modal.item?.isNewPosition,
                        }
                    };
                }

                if(!this.modal.item.quantity) {
                    this.modal.item.quantity = 1
                }

                if(this.modal.item.restaurant && this.modal.item.restaurant.id) {
                    await this.getRestaurantDishes(this.modal.item.restaurant.id);
                }

                if(this.modal.item.restaurant && this.modal.item.restaurant.id && this.modal.item.dish && this.modal.item.dish.id) {
                    await this.getDishModifiers(this.modal.item.restaurant.id, this.modal.item.dish.id);
                    await this.getDishModifiersGroups(this.modal.item.restaurant.id, this.modal.item.dish.id);
                    await this.getDishIngredients(this.modal.item.restaurant.id, this.modal.item.dish.id);
                    await this.getDishIngredientsGroups(this.modal.item.restaurant.id, this.modal.item.dish.id);
                }
            },
            modal: {
                deep: true,
                handler() {
                    if (this?.modal?.item?.refund_for
                        && !this?.modal?.item?.refund_sum
                        && this?.modal?.item?.refund_sum !== 0
                    && this?.modal?.item?.refund_sum !== '') {
                        this.modal.item.refund_sum = this.modal.item.price * this.modal.item.quantity;
                    }
                }
            }
        },

        async mounted() {
            const orderId = parseInt(this.$route.params.id);
            try {
                const orderResp = await Vue.axios.get(`/orders/${orderId}`);
                this.order = JSON.parse(JSON.stringify(orderResp.data));
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка при загрузке данных о заказе.');
            }
        },

        methods: {
            getDished (search) {
                return new Promise(resolve => {
                    if (search.length < 2) {
                        return resolve([]);
                    }

                    Vue.axios
                        .get(`/restaurants/${ this.modal.item.restaurant.id }/inactive_dishes?search=${ search }`, {})
                        .then(resp => {
                            resolve(resp.data.results);
                        })
                        .catch(err => {
                            console.log('Cannot load dishes list.');
                        });
                });
            },
            async updateDishes(dish) {
                this.modal.item = {
                    ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                    ...{
                        id: this.modal.item.id,
                        restaurant: {
                            id: this.modal.item.restaurant.id,
                            title: this.modal.item.restaurant.title,
                        },
                        dish: {
                            id: dish.id,
                            title: dish.title,
                            price: dish.price,
                            promotion_id: dish.promotion_id,
                        },
                        dish_id: dish.id,
                        dish_title: dish.title,
                        dish_price: dish.price,
                        isNewPosition: this.modal.item?.isNewPosition
                    }
                };
            },
            getResultValue(result) {
                return result.title;
            },
            formatDate(date) {
                return formatDate(date);
            },
            async getRestaurantDishes(restaurantId) {
                try {
                    const { data } = await Vue.axios.get(`/restaurants/${ restaurantId }/inactive_dishes`);
                    data.sort((a, b) => a.title > b.title ? 1 : -1);
                    this.dishes = data.map(dish => {
                        return {
                            value: dish.id,
                            label: dish.title + ' - ' + dish.price + ' р.',
                            title: dish.title,
                            price: dish.price,
                            promotion_id: dish.promotion_id,
                        }
                    });
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getDishIngredients(restaurantId, dishId) {
                try {
                    const { data } = await Vue.axios.get(`/restaurants/${ restaurantId }/dishes/get-ingredients/${ dishId }`);
                    this.ingredients = data;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getDishModifiers(restaurantId, dishId) {
                try {
                    const { data } = await Vue.axios.get(`/restaurants/${ restaurantId }/dishes/get-modifiers/${ dishId }`);
                    this.modifiers = data;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');   
                }
            },
            async getDishIngredientsGroups(restaurantId, dishId) {
                try {
                    const { data } = await Vue.axios.get(`/restaurants/${ restaurantId }/dishes/ingredient-groups/${ dishId }`);
                    this.ingredientsGroup = data;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            async getDishModifiersGroups(restaurantId, dishId) {
                try {
                    const { data } = await Vue.axios.get(`/restaurants/${restaurantId}/dishes/modifier-groups/${dishId}`);
                    this.modifiersGroup = data;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async updateDish(value) {
                for(let i=0; i < this.dishes.length; i++) {
                    if(value === this.dishes[i].value) {
                        this.modal.item = {
                            ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                            ...{
                                id: this.modal.item.id,
                                restaurant: {
                                    id: this.modal.item.restaurant.id,
                                    title: this.modal.item.restaurant.title,
                                },
                                dish: {
                                    id: this.dishes[i].value,
                                    title: this.dishes[i].title,
                                    price: this.dishes[i].price,
                                    promotion_id: this.dishes[i].promotion_id,
                                },
                                dish_id: this.dishes[i].value,
                                dish_title: this.dishes[i].title,
                                dish_price: this.dishes[i].price,
                                isNewPosition: this.modal.item?.isNewPosition
                            }
                        };
                    }
                }
                await this.getDishIngredients(this.modal.item.restaurant.id, this.modal.item.dish.id);
                await this.getDishModifiers(this.modal.item.restaurant.id, this.modal.item.dish.id);
                await this.getDishIngredientsGroups(this.modal.item.restaurant.id, this.modal.item.dish.id);
                await this.getDishModifiersGroups(this.modal.item.restaurant.id, this.modal.item.dish.id);
                this.recalculatePrice();
            },
            updateRefund(refundFor) {
                this.modal.item.refund_for = refundFor;
            },
            updateModifiers(checked, obj) {
                for(let i=0; i < this.modifiers.length; i++) {
                    if(+obj.target.value === this.modifiers[i].id) {
                        this.modal.item.modifiers = [{
                            ...this.modifiers[i]
                        }];
                    }
                }
                this.recalculatePrice();
            },

            updateModifiersGroup(checked, obj) {
                if(checked) {
                    for (const group of this.modifiersGroup) {
                        for (const modifier of group.modifiers) {
                            if(+obj.target.value === +modifier.id) {
                                this.modal.item.modifiers.push(modifier)
                            }
                        }
                    }
                } else {
                    for(let i=0; i < this.modal.item.modifiers.length; i++) {
                        if(+obj.target.value === +this.modal.item.modifiers[i].id) {
                            this.modal.item.modifiers.splice(i, 1);
                        }
                    }
                }
                this.recalculatePrice();
            },
            
            updateIngredients(checked, obj) {
                if(checked) {
                    for(let i=0; i < this.ingredients.length; i++) {
                        if(+obj.target.value === +this.ingredients[i].id) {
                            this.modal.item.ingredients.push(this.ingredients[i]);
                        }
                    }
                } else {
                    for(let i=0; i < this.modal.item.ingredients.length; i++) {
                        if(+obj.target.value === +this.modal.item.ingredients[i].id) {
                            this.modal.item.ingredients.splice(i, 1);
                        }
                    }
                }
                this.recalculatePrice();
            },

            updateIngredientsGroup(checked, obj) {
                if(checked) {
                    for (const group of this.ingredientsGroup) {
                        for (const ingridient of group.ingredients) {
                            if(+obj.target.value === +ingridient.id) {
                                this.modal.item.ingredients.push(ingridient)
                            }
                        }
                    }
                } else {
                    for(let i=0; i < this.modal.item.ingredients.length; i++) {
                        if(+obj.target.value === +this.modal.item.ingredients[i].id) {
                            this.modal.item.ingredients.splice(i, 1);
                        }
                    }
                }
                this.recalculatePrice();
            },

            recalculatePrice() {
                let price = +this.modal.item.dish.price;
                for(let i=0; i < this.modal.item.modifiers.length; i++) {
                    price += +this.modal.item.modifiers[i].price;
                }
                for(let i=0; i < this.modal.item.ingredients.length; i++) {
                    price += +this.modal.item.ingredients[i].price;
                }
                this.modal.item.price = price;
            }
        },
    };
</script>

<style scoped>
.danger {
    color: red;
}
</style>
